import styled from 'styled-components';

export const RecommendedRulesStyled = styled.div`
  .condition-item {
    flex: 1;
  }
`;
